import { render, staticRenderFns } from "./ExamInfo.vue?vue&type=template&id=d628ccd2&scoped=true&"
import script from "./ExamInfo.vue?vue&type=script&lang=js&"
export * from "./ExamInfo.vue?vue&type=script&lang=js&"
import style0 from "./ExamInfo.vue?vue&type=style&index=0&id=d628ccd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d628ccd2",
  null
  
)

export default component.exports